import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { LoginProvider } from "./context/Login_context";
import { DashboardProvider } from "./context/Dashboard_context";
import { BasicProvider } from "./context/Basic_context";
import { ProfileProvider } from "./context/Profile_context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LoginProvider>
    <ProfileProvider>
      <BasicProvider>
        <DashboardProvider>
          <App />
        </DashboardProvider>
      </BasicProvider>
    </ProfileProvider>
  </LoginProvider>,
);
